<template>
  <div id="app">
    <div v-if="headerShow">
      <Header></Header>
    </div>
    <router-view />
    <div v-if="headerShow">
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import Header from "./components/Header";
import Footer from "./components/Footer";

export default {
  name: "App",
  data() {
    return {
      headerShow: true
    };
  },
  created() {
    if (this._isMobile()) {
      // alert("手机端");
      window.location.href = "https://wap.aijiehu.cn";
    }
    //  else {
    //   // alert("pc端");
    //   window.location.href = "https://www.aijiehu.cn";
    // }
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    }
  },
  components: {
    Header,
    Footer
  },
  watch: {
    $route(to, from) {
      if (to.path == "/newsdetail") {
        this.headerShow = false;
      } else if (to.path == "/bannerlive") {
        this.headerShow = false;
      } else {
        this.headerShow = true;
      }
      if (to.path == "/about") {
        this.$EventBus.$emit("nums", 2);
      } else if (to.path == "/newscenter") {
        this.$EventBus.$emit("nums", 3);
      } else if (to.path == "/serve") {
        this.$EventBus.$emit("nums", 4);
      } else if (to.path == "/site") {
        this.$EventBus.$emit("nums", 5);
      } else if (to.path == "/join") {
        this.$EventBus.$emit("nums", 6);
      } else {
        this.$EventBus.$emit("nums", 1);
      }
    }
  }
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  font-family: "SourceHanSansCN";
  width: 1920px;
  margin: auto;
}
a {
  text-decoration: none;
}
/*包含以下四种的链接*/

/*正常的未被访问过的链接*/
a:link {
  text-decoration: none;
}
/*已经访问过的链接*/
a:visited {
  text-decoration: none;
}
/*鼠标划过(停留)的链接*/
a:hover {
  text-decoration: none;
}
/* 正在点击的链接*/
a:active {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue